import script from "./InfoStudentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoStudentComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__